import { Edit } from '@mui/icons-material';
import { Grid, IconButton, Stack, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import RowDetails from '../../../../../components/RowDetails';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';


const CardInfo = ({ item, handleEditTask,setIsOpenSurveyQuestionDialog }) => {
  const {t} = useTranslation()
    return (
        <Grid
            sx={{
                borderRight: { xs: "none", md: `1px dashed ${grey[200]}` },
                display: "flex", flexDirection: "column", justifyContent: "space-between"
            }}
            size={{
                xs: 12,
                md: 4
            }}>
            <Grid container spacing={0.5} sx={{
                px: 2
            }}
            >
                <Grid size={{ xs: 12 }}>
                    <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                        <Stack direction={"row"} alignItems={"center"}>
                            <Typography variant="subtitle2">
                                {item?.title}
                            </Typography>
                        </Stack>
              {item?.isHiddenEditIcon && <Stack direction={"row"} alignItems={"center"}>
                <IconButton onClick={() => {
                  handleEditTask(item?.type)
                }
                }
                  disabled={item?.isDisable}
                >
                  <Edit />
                </IconButton>
              </Stack>}
                    </Stack>
                </Grid>
                {item?.details?.map((detail) => {
                    return <Grid key={detail?.title} size={{ xs: 12 }}>
                        <RowDetails disabled ={item?.isDisabled} title={detail?.title} value={!item?.isDisabled ? detail.value : ""} />
                    </Grid>;
                })}
            </Grid>
             {item?.isPreviewDisplay && (
                    <Grid size={{ xs: 12 }} sx={{
                      px: 2, py: 1.5,
                    }}>
                      <Stack direction="row" sx={{
                        justifyContent: "space-between"
                      }}> 
                        <Typography variant="caption" component="p"sx={{color: "text.secondary", }} >{t('general.form')}</Typography>
                        <Stack
                          direction="row"
                          spacing={0.5}
                          sx={{
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          
                          <IconButton
                            onClick={()=> setIsOpenSurveyQuestionDialog (true)}
                            aria-label="Edit"
                            size="small"
                          >
                            <Edit  />
                          </IconButton>
                        </Stack>
                      </Stack>
                      <Box
                        sx={{
                          borderRadius: 1,
                          height: 300,
                          p: 1.5,
                          overflow: "auto",
                        }}
                      >
                          <Box
                            sx={{ fontSize: 12, cursor: "pointer" }}
                          />
                      </Box>
                    </Grid>
                  )}
        </Grid>
    )
}

export default CardInfo